import { Modal, ModalContents } from '@controlrooms/components';

interface ConfirmCloseModalProps {
  onConfirm: (closeState: boolean) => void;
  /** Use 'collection' for collection close; defaults to 'tab' */
  entityType?: 'tab' | 'collection';
}

const COPY = {
  tab: {
    title: 'Confirm to close tab',
    body: 'Are you sure you want to close this tab?',
    confirmButton: 'Close Tab',
  },
  collection: {
    title: 'Confirm to close collection',
    body: 'Are you sure you want to close this collection?',
    confirmButton: 'Close Collection',
  },
};

export const ConfirmCloseModal = ({ onConfirm, entityType = 'tab' }: ConfirmCloseModalProps) => {
  const { title, body, confirmButton } = COPY[entityType];
  return (
    <Modal open={true}>
      <ModalContents
        title={title}
        styles={{ content: { minWidth: '450px' } }}
        confirmButtonText={confirmButton}
        closeButtonText="Cancel"
        closeButtonCallback={() => {
          onConfirm(false);
        }}
        shouldCloseOnEsc={false}
        confirmButtonCallback={async () => {
          onConfirm(true);
        }}
        dataTestIdCancel="modal-close-icon-delete-alert"
      >
        <div style={{ padding: '10px', fontSize: '13px' }}>
          <p>{body}</p>
        </div>
      </ModalContents>
    </Modal>
  );
};
